import Hero from '../components/Hero';
import Gallery from '../components/Gallery';
import Services from '../components/Services';
import Why from '../components/Why';
import Process from '../components/Process';
import ContactUs from '../components/ContactUs';

const HomePage = () => (
  <>
    <Hero />
    <Gallery />
    <Services />
    <Why />
    <Process />
    <ContactUs />
  </>
);

export default HomePage;
